export default {
    FULL: 1,
    PARTIAL: 2,
    NONE: 0,
    DECLINE: -1,
}